import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="group">
      <article className="bg-white rounded-lg overflow-hidden border border-stroke hover:shadow-lg hover:border-primary/20 transition-all duration-300 h-full flex flex-col">
        {/* Featured Image */}
        {post.featuredImage && (
          <div className="relative overflow-hidden h-48">
            <img
              src={post.featuredImage}
              alt={post.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            {post.category && (
              <span className="absolute top-3 left-3 px-3 py-1 text-12 font-medium text-white bg-primary rounded-full">
                {post.category.name}
              </span>
            )}
          </div>
        )}

        {/* Content */}
        <div className="p-6 flex flex-col flex-grow">
          {/* Title */}
          <h3 className="text-20 font-medium text-secondary group-hover:text-primary transition-colors mb-2 line-clamp-2">
            {post.title}
          </h3>

          {/* Excerpt */}
          <p className="text-14 text-light-gray line-clamp-3 mb-4 flex-grow">
            {post.excerpt}
          </p>

          {/* Meta */}
          <div className="flex items-center justify-between text-12 text-light-gray pt-4 border-t border-stroke">
            <div className="flex items-center gap-2">
              {post.author?.avatar && (
                <img
                  src={post.author.avatar}
                  alt={post.author.name}
                  className="w-6 h-6 rounded-full"
                />
              )}
              <span>{post.author?.name}</span>
            </div>
            {post.readTime && (
              <span>{post.readTime} min read</span>
            )}
          </div>
        </div>
      </article>
    </Link>
  );
}
